/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'

import { navbarHeight, footerHeight, positionChangeWidthSm } from '../../../../helpers/variableDefaults'
import { newFriendReviewerTextField } from '../../../../helpers/textfields'
import { advisoryTypography } from '../../../../helpers/typographies'
import { standardButton, deleteFriendIconButton } from '../../../../helpers/buttons'
import { noDuplicatesInArray } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'

export const addFriendReviewersJSX = (friendReviewersArray, setFriendReviewersArray, removeFriend, handleAddFriend, allFriendReviewerInfoAdded, friendProceedToPaymentButtonDisabled, handleFriendProceedToPaymentPressed, newFriendErrors, setNewFriendErrors, width) => {
  return (
    <Box
      sx={{
        mt: 2, mb: 6,
        pt: 2, pb: 4,
        backgroundColor: 'whitesmoke',
        boxShadow: 3,
        borderRadius: '5px',
        width: '95%',
        // maxWidth: '600px',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
      }}
    >

      {/* Title and Advisory */}
      <Box
        sx={{
          mb: 2,
          width: '100%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          Friend Reviewer(s)
        </Typography>

        {friendReviewersArray.map((friendReviewer, friendReviewerIndex) => ( 
          // Friend To Add
          <Box
            key={friendReviewerIndex}
            sx={{
              mt: width < positionChangeWidthSm ? 2 : 0.5, 
              pt: width < positionChangeWidthSm ? 1 : 0, pb: width < positionChangeWidthSm && friendReviewersArray.length === 1 ? 2 : 0, 
              backgroundColor: width < positionChangeWidthSm ? 'gray' : '',
              boxShadow: width < positionChangeWidthSm ? 3 : 0, borderRadius: width < positionChangeWidthSm ? '5px' : '0px',
              width: '90%', 
              maxWidth: friendReviewersArray.length === 1 ? positionChangeWidthSm : positionChangeWidthSm,
              display: 'flex', flexDirection: width < positionChangeWidthSm ? 'column' : 'row', justifyContent: width < positionChangeWidthSm ? 'center' : 'space-between', alignItems: width < positionChangeWidthSm ? 'center' : 'center',
            }}
          >

            {/* Name of Taker */}
            {newFriendReviewerTextField(
              'firstName',
              friendReviewer.firstName,
              'First Name',
              'outlined',
              friendReviewersArray,
              setFriendReviewersArray,
              setNewFriendErrors,
              'md',
              width,
              friendReviewerIndex
            )}

            {/* Email of Taker */}
            {newFriendReviewerTextField(
              'email',
              friendReviewer.email,
              'Email',
              'outlined',
              friendReviewersArray,
              setFriendReviewersArray,
              setNewFriendErrors,
              'md',
              width,
              friendReviewerIndex
            )}

            {/* Delete Recipient Button */}
            {friendReviewersArray.length > 1 && 
              <Box
                sx={{
                  // position: width < positionChangeWidthSm ? '' : 'absolute',
                  // left: width < positionChangeWidthSm ? '' : width < positionChangeWidthMd ? '82%' : `calc(50% + 290px)`,
                  // ml: width < positionChangeWidthSm ? 0 :  1,
                }}
              >
                {deleteFriendIconButton(
                  removeFriend,
                  friendReviewerIndex,
                  friendReviewersArray.length <= 1,
                  0,
                  0,
                  0
                )}
              </Box>
            }
          </Box>
        ))}

        {/* Add Another Friend */}
        <Box key={5} 
          sx={{ 
            mb: 0, mt: width < positionChangeWidthSm ? 3 : 1,
            width: '100%', 
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', 
          }}
        >
          {/* {console.log('allRecipientsAdded ->', allRecipientsAdded())} */}
          <Button 
            key={7} 
            disabled={(!allFriendReviewerInfoAdded())}
            onClick={handleAddFriend}
            color='primary'
          >
            ADD ANOTHER FRIEND
          </Button>
        </Box>

        {/* Duplicate Emails Advisory */}
        {!noDuplicatesInArray(friendReviewersArray.map(friendReviewer => friendReviewer.email)) &&
          <Typography 
            sx={{
              color: 'red',
              width: '100%',
              display: 'flex', flexDirection: 'row', justifyContent: 'center',
            }}
          >
            <em>The same email cannot be used for two friends</em>
          </Typography>
        }

        {/* Review And Pay Buttons */}
        <Box
          sx={{
            mt: width < positionChangeWidthSm ? 2 : 4, pb: 4,
            width: '90%', maxWidth: '450px',
            display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
          }}
        >
          {standardButton(
            'Next', 
            'button',
            'contained',
            friendProceedToPaymentButtonDisabled(),
            'primary', 
            0,
            0,
            0,
            '220px', 
            '45px', 
            handleFriendProceedToPaymentPressed
          )}
        </Box>


        {newFriendErrors &&
          standardErrorContainer(
            'There was an error adding your friend reviewer.',
            1,
            1
          )
        }

      </Box>
    </Box>
  )
}